export const getEditorOptions = () => {
  return {
    options: ['blockType', 'inline', 'history', 'list', 'textAlign'],
    inline: {
      inDropdown: false,
      options: ['italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
    },
  };
};
